import React from 'react';
import cls from 'classnames';
import { Draggable, Droppable } from '@hello-pangea/dnd';
import LowboyRequestCardBody from './LowboyRequestCardBody';

export default class LowboyResourceCard extends React.Component {
    isValidHover(snapshot) {
        return this.isHover(snapshot) && this.isAllowed(snapshot);
    }

    isInvalidHover(snapshot) {
        return this.isHover(snapshot) && !this.isAllowed(snapshot);
    }

    isHover(snapshot) {
        return snapshot && snapshot.isDraggingOver;
    }

    isAllowed(snapshot) {
        const { equipments, lowboyResource } = this.props;

        if (!snapshot || !snapshot.draggingOverWith) {
            return false;
        }

        const equipmentId = snapshot.draggingOverWith.replace('eq-', '');

        const equipment = equipments.find((eq) => eq.id == equipmentId);

        return lowboyResource.equipmentTypeId == equipment.equipmentTypeId;
    }

    getLowboyAssignmentId() {
        const { lowboyResource, index } = this.props;

        return lowboyResource.lowboyAssignmentIds[index];
    }

    getLowboyAssignment() {
        const { lowboyAssignments } = this.props;
        const lowboyAssignmentId = this.getLowboyAssignmentId();

        return lowboyAssignments.find((la) => la.id == lowboyAssignmentId);
    }

    isAssignedToEmployee() {
        const lowboyAssignment = this.getLowboyAssignment();

        return lowboyAssignment && lowboyAssignment.employeeId;
    }

    renderCardBody(snapshot) {
        const { lowboyResource, cardIndex, equipmentTypes, equipments } =
            this.props;

        const equipmentType = equipmentTypes.find(
            (et) => et.id == lowboyResource.equipmentTypeId
        );

        const lowboyAssignment = this.getLowboyAssignment();

        const equipment = equipments.find(
            (eq) => (lowboyAssignment || {}).equipmentId == eq.id
        );

        const equipmentAssigned = Boolean(equipment);

        const { onResourceCardClick } = this.props;

        return (
            <div
                id={`lr-drop-${cardIndex}`}
                className={cls('card w-100', {
                    'drop-resource-card': this.isDroppable(),
                    'resource-card': this.isDraggable(),
                    'hover-valid': this.isValidHover(snapshot),
                    'hover-invalid': this.isInvalidHover(snapshot),
                })}
                onClick={
                    !equipmentAssigned && onResourceCardClick
                        ? () =>
                              onResourceCardClick(
                                  lowboyResource.equipmentTypeId
                              )
                        : undefined
                }
            >
                <LowboyRequestCardBody
                    {...this.props}
                    showDragIndicator={equipmentAssigned}
                    lowboyResource={lowboyResource}
                    equipmentType={equipmentType}
                    lowboyAssignment={lowboyAssignment}
                    equipment={equipment}
                    removeCargoEnabled={
                        equipmentAssigned && !(snapshot && snapshot.isDragging)
                    }
                />
            </div>
        );
    }

    isDroppable() {
        const { lowboyResource, index } = this.props;

        const openAssignmentCount =
            lowboyResource.requestedResourceCount -
            lowboyResource.lowboyAssignmentIds.length;

        return (
            openAssignmentCount > 0 &&
            !lowboyResource.lowboyAssignmentIds[index]
        );
    }

    isDraggable() {
        const { lowboyResource, index } = this.props;

        return Boolean(lowboyResource.lowboyAssignmentIds[index]);
    }

    render() {
        const { lowboyResource, cardIndex } = this.props;

        if (!lowboyResource || this.isAssignedToEmployee()) {
            return null;
        }

        const droppableId = `resource-droppable${cardIndex}-${lowboyResource.id}`;

        if (this.isDroppable()) {
            return (
                <Droppable droppableId={droppableId}>
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className="resource-card-container"
                        >
                            {this.renderCardBody(snapshot)}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            );
        }

        if (this.isDraggable()) {
            const lowboyAssignmentId = this.getLowboyAssignmentId();
            const draggableId = `resource-draggable${cardIndex}-${lowboyAssignmentId}`;
            const containerDroppableId = `inner-${droppableId}`;

            return (
                <Droppable droppableId={containerDroppableId}>
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                        >
                            <Draggable
                                draggableId={draggableId}
                                index={cardIndex}
                                key={lowboyAssignmentId}
                            >
                                {(innerProvided, innerSnapshot) => (
                                    <div
                                        ref={innerProvided.innerRef}
                                        {...innerProvided.draggableProps}
                                        {...innerProvided.dragHandleProps}
                                    >
                                        {this.renderCardBody(innerSnapshot)}
                                        {innerProvided.placeholder}
                                    </div>
                                )}
                            </Draggable>
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            );
        }

        return <>{this.renderCardBody()}</>;
    }
}
